import { render, staticRenderFns } from "./ModalAddGestores.vue?vue&type=template&id=160a7f3e&scoped=true"
import script from "./ModalAddGestores.vue?vue&type=script&lang=ts"
export * from "./ModalAddGestores.vue?vue&type=script&lang=ts"
import style0 from "./ModalAddGestores.vue?vue&type=style&index=0&id=160a7f3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160a7f3e",
  null
  
)

export default component.exports